import { AnalyticsBrowser } from "@segment/analytics-next";
import axios from "axios";
import {
  PaginatedSecondaryDealsDto,
  SecondaryDealsDto,
} from "../../generated/bops";
import { featureFlag, isProd } from "../featureFlags/featureFlags";

function getSegmentOnEnvs(): string[] {
  const envs = JSON.parse(
    process.env.NEXT_PUBLIC_SEGMENT_ON_ENVIRONMENT || "[]"
  );
  return envs;
}

const envs = getSegmentOnEnvs();

let shouldActivateSegmentInEnv;
if (typeof window !== "undefined") {
  shouldActivateSegmentInEnv = Boolean(
    envs.find((env) => window.location.hostname.includes(env))
  );
}

let _analytics: AnalyticsBrowser = {
  track: async () => null,
  identify: async () => null,
  page: async () => null,
  reset: async () => null,
} as unknown as AnalyticsBrowser;

if (featureFlag("segment") && (isProd() || shouldActivateSegmentInEnv)) {
  if (process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY) {
    _analytics = AnalyticsBrowser.load({
      writeKey: process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY,
    });
  }
}

export function useSegmentAnalytics() {
  async function trackSecondaryListingPageVisit(slug: string) {
    let currentDeal: SecondaryDealsDto | undefined;
    const key = "secondaryDeals";
    const allSecondaryDealsStr = window["sessionStorage"][key];
    if (!allSecondaryDealsStr) {
      const response = await axios.get<PaginatedSecondaryDealsDto>(
        "/api/deals/secondaries?page=1&limit=300"
      );
      window["sessionStorage"].setItem(key, JSON.stringify(response.data));
      currentDeal = response.data.data.find(
        (deal: SecondaryDealsDto) => deal.slug === slug
      );
    } else {
      const allSecondaryDeals = JSON.parse(
        allSecondaryDealsStr
      ) as PaginatedSecondaryDealsDto;
      currentDeal = allSecondaryDeals.data.find(
        (deal: SecondaryDealsDto) => deal.slug === slug
      );
    }

    if (currentDeal) {
      _analytics.track("Secondary Asset Page Visited", {
        assetId: currentDeal.asset_id,
        assetType: currentDeal.security_type,
        dealName: currentDeal.name,
        currency: currentDeal.currency,
        isTradable: currentDeal.is_tradable,
        lastPrice: currentDeal.lastest_price,
        buyPrice: currentDeal.buy_price,
        sellPrice: currentDeal.sell_price,
      });
    }
  }
  return { segmentAnalytics: _analytics, trackSecondaryListingPageVisit };
}

export const analytics = _analytics;
